module.exports = __webpack_public_path__ + "static/media/spin-mobile.a165228d.jpg";